export const RETURN_URL_KEY = 'returnUrl'

const BLOCKED_PATHS = ['/login', '/authentication/new']
const MAX_URL_LENGTH = 2048

/**
 * Extracts the pathname portion of a URL string by finding the first
 * occurrence of '?' or '#' and returning everything before it.
 *
 * @param {string} url - A relative URL string (e.g., '/transactions/123?tab=details')
 * @returns {string} - The pathname without query string or hash fragment
 */
function extractPathname(url) {
  const separatorIndex = url.search(/[?#]/)

  return separatorIndex === -1 ? url : url.slice(0, separatorIndex)
}

/**
 * Validates a stored return URL to prevent open redirect attacks.
 *
 * @param {string} url - The URL to validate
 * @returns {boolean} - true if the URL is safe to redirect to
 */
export function validateReturnUrl(url) {
  if (typeof url !== 'string') return false
  if (url.length > MAX_URL_LENGTH) return false
  if (!url.startsWith('/')) return false
  if (url.startsWith('//')) return false

  const pathname = extractPathname(url)
  const normalizedPath = pathname.replace(/\/+$/, '') || '/'

  return !BLOCKED_PATHS.includes(normalizedPath)
}

/**
 * Stores the return URL in sessionStorage.
 * Used before redirecting to the SSO server so the user can be
 * returned to their original page after login.
 *
 * @param {Location|URL} [location=window.location] - The location object to read pathname, search, and hash from.
 */
export function storeReturnUrl(location = window.location) {
  try {
    const returnUrl = location.pathname + location.search + location.hash

    sessionStorage.setItem(RETURN_URL_KEY, returnUrl)
  } catch {
    // Silently continue if sessionStorage is unavailable
  }
}
